<template>
  <div class="container disp-ali-cen-fldir-col" v-wechat-title="$route.meta.title">
	<div class="topTitle"><img @click="backLast" class="backImg" src="../assets/pingzi/back.png" alt="">{{$route.meta.title}}</div>
	<div style="width: 100%;height: 0.8rem;background: transparent;"></div>
	<div style="width: 100%;">
		<div v-if="!emptyShow" class="addressContent disp-just-aro-ali-cen" v-for="(item,index) in addressArr">
		  <div class="addressInfo"  @click="selectAdd(item.Id)">
			<div class="">
			  <div class="disp-just-bet-ali-cen">
				<div style="width:50%;">收货人：{{item.Contacts}}</div>
				<div>{{item.Mobile}}</div>
				<i class="moren" v-if="item.IsdefaultAddress == 1">默认</i>
				<i class="" v-if="item.IsdefaultAddress == 0"></i>
			  </div>
			  <div>收货地址：{{item.address}}</div>
			</div>
			
			<div class="caozuo disp-just-flend-ali-cen">
			  <div class="dad disp-just-flend-ali-cen" @click.stop="deleteAddress(item.Id)">
				<img src="../assets/icon/del.png">
			  </div>
			  <div class="disp-just-flend-ali-cen" @click.stop="changeAdd(item.Id)">
				<img src="../assets/icon/xiugai01.png"/>
			  </div>
			</div>
		  </div>
		</div>
		<div style="width:100%;height:1.4rem;background-color:transparent;"></div>
		<div class="sureAddress" hover-class="btnHover" @click="toAddMyaddress">
		  <i>新增地址</i>
		</div>
		<div v-if="emptyShow" class="emptyBox">
			<img class="emptyImg" style="" src="../assets/pingzi/goodsEmpty.png" alt="">
			<div class="textEmpty">暂无可用地址</div>
		</div>
	</div>
  </div>
</template>

<script>

import '../styles/blues.css'
import '../styles/base1.css'
import util from '../utils/util'
import $ from '../utils/axios'
import axiosp from '../utils/axiosp'
import { Dialog, Toast } from 'vant';

export default {
  name: 'myAddress',
  components: {

  },
  data () {
    return {
      addressArr:[],
	  from:"",
	  emptyShow:false,
    }
  },
  created () {
    this.$emit('footer', false);
  },
  mounted() {
	this.from = this.$route.query.from;
    this.findAddressList();
  },
  beforeDestroy() {
    Dialog.close();
  },
  methods:{
	backLast(){
		this.$router.go(-1);//返回上一层
	},
	selectAdd(id) {
	  if(this.from == 'mine'){
      
	  }else{
        
      let item =  this.addressArr.find(item =>  item.Id == id)
      

      if(!item.Mobile){
        Toast("请先完善该收货地址的手机号");
        return;
      }
      
      // util.setSto('addAdd',item.CompleteAddress)
      // util.setSto('addName',item.Contacts)
      // util.setSto('addMobile',item.Mobile)
      // util.setSto('addId',item.Id)

      sessionStorage.setItem('addAdd', item.CompleteAddress);
      sessionStorage.setItem('addName',item.Contacts)
      sessionStorage.setItem('addMobile',item.Mobile)
      sessionStorage.setItem('addId',item.Id)
      this.$router.go(-1);//返回上一层
	  }
	},
    toAddMyaddress() {
      this.$router.push('/addAddress')
    },
    // 获取地址
    findAddressList(){
      this.$parent.Loading(true)
      
      axiosp.reqPost(
          "User/GetUserAddress",{
        GetClass: 0
      }).then(res => {
        
        if(res.Data && res.Data.length){
          
          for(var i = 0;i<res.Data.length;i++){
            res.Data[i].img = "../images/pingzi/rd-uncheck.png";
            res.Data[i].editShow = false;
            res.Data[i].address = res.Data[i].CompleteAddress;
          }
		  this.emptyShow = false;
        }else{
			this.emptyShow = true;
		}
        this.addressArr = res.Data;
        this.$parent.Loading(false)
      })
    },
    // 删除地址交互
    deleteAddress(id){
      var that = this;
      Dialog.confirm({
        title: '',
        message: '确认删除该地址？',
        confirmButtonColor: '#4fae54',
        beforeClose
      });

      function beforeClose(action, done) {
        if (action === 'confirm') {
          that.del(id);
          setTimeout(done, 500);
        } else {
          done();
        }
      }
    },
    // 删除地址
    del(id) {
      this.$parent.Loading(true)
      axiosp.reqPost('User/DelUserAddress',{
        Id:id
      }).then(res => {
        util.toast("删除成功");
        this.findAddressList();
      }).catch(err => {
        console.log(err)
      }).finally(()=>{
        this.$parent.Loading(false)
      })
    },
    // 修改地址
    changeAdd(id) {
      
      this.$router.push(`/addAddress?id=${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245,245,245)!important;
  position: relative;
}
.emptyBox{
	width:100%;
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top:0.5rem;
	.emptyImg{
		width: 2.51rem;
		height: 2.05rem;
		margin-bottom: 0.3rem;
	}
	.textEmpty{
		width: 100%;
		text-align: center;
		color: #B4B4B4;
		font-size: 0.26rem;
	}
}
.addAddress{
  width: 95%;
  margin: 0.10rem 0 0.20rem;
  img{
    width: 0.50rem;
    height: 0.50rem;
  }
  div{
    font-size: 0.30rem;
  }
}
.addressContent{
  width: 100%;
  // margin-bottom: 0.1rem;
  // margin-top: 0.8rem;
  .dian{
    width: 0.40rem;
    height: 0.40rem;
    margin-left: 0.10rem;
  }
  .addressInfo{
    width: 92%;
    margin: 0.30rem auto;
    border-radius: 0.20rem;
    background-color: #fff;
    padding: 0 0.30rem;
    box-sizing: border-box;
    color: #383838;
    div{
      font-size: 0.28rem;
      margin: 0.15rem 0;
    }
  }
}
.sureAddress{
  position: fixed;
  bottom: 0;
  // left: 0.25rem;
  width: 94%;
  margin: 0 3% 0.4rem;
  height: 1.08rem;
  line-height: 1.08rem;
  font-size: 0.34rem;
  text-align: center;
  background:rgba(79,174,84,1);
  box-shadow:0rem 0.09rem 0.07rem 1px rgba(79,174,84,0.19);
  border-radius:0.10rem;
  i{
    color: white;
  }
}
button::after{
  border: none;
  border-radius: 0;
}
.caozuo{
  width: 100%;
  height: 0.80rem;
  .dad{
    margin-right: 0.20rem;
    img{
      width: 0.40rem;
      height: 0.46rem;
    }
  }
  div{
    width: 1.00rem;
    height: 0.80rem;
    font-size: 0.28rem;
    color: rgb(188,188,188);
    img{
      width: 0.40rem;
      height: 0.40rem;
      margin-right: 0.10rem;
    }
  }
}
.addActBtn{
  width:0.80rem;
  height: 0.80rem;
  border-radius: 50%;
  position: fixed;
  background-color: white;
  bottom: 20.50rem;
  right: 0.20rem;
  z-index: 5;
}
.moren{
  display: block;
  background: #FF5A2E;
  color: #fff;
  text-align: center;
  width: 0.60rem;
  font-size: 0.24rem;
  padding: 0.06rem;
  border-radius: 0.30rem;
}
</style>
